/* CDX „Mehr anzeigen" — truncatet [data-cdx-more]-Blöcke und zeigt den Button nur bei Überlauf. */
(function () {
  function init() {
    document.querySelectorAll('[data-cdx-more]').forEach(function (box) {
      if (box.dataset.moreReady) return;
      box.dataset.moreReady = '1';
      var content = box.querySelector('[data-cdx-more-content]');
      var btn = box.querySelector('[data-cdx-more-btn]');
      if (!content || !btn) return;
      var lbl = btn.querySelector('[data-more-lbl]');
      function refresh() {
        if (box.classList.contains('is-expanded')) { btn.style.display = 'inline-flex'; box.classList.remove('is-truncated'); return; }
        var over = content.scrollHeight > content.clientHeight + 4;
        btn.style.display = over ? 'inline-flex' : 'none';
        box.classList.toggle('is-truncated', over);
      }
      btn.addEventListener('click', function () {
        var exp = box.classList.toggle('is-expanded');
        if (lbl) lbl.textContent = exp ? btT('cdx_more.show_less', 'Weniger anzeigen') : btT('cdx_more.show_more', 'Mehr anzeigen');
        refresh();
      });
      refresh();
      window.addEventListener('resize', refresh);
    });
  }
  window.__cdxMore = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
